import React from 'react'
import classNames from 'classnames'
import MenuDotsIcon from '~images/menu-dots-icon.svg'

export const BurgerMenu: React.FC<any> = ({ link, onClick }) => {
  const [isActiveMenu, setActiveMenu] = React.useState<boolean>(false)

  const handleToggle = () => {
    setActiveMenu(!isActiveMenu)
    if (!isActiveMenu) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'visible'
    }
  }
  return (
    <>
      <div
        onClick={handleToggle}
        className={classNames('onlinepbx__burger__menu', {
          'onlinepbx__burger__menu__active': isActiveMenu
        })}>
        <div className='onlinepbx__burger__menu__dots'><MenuDotsIcon /></div>
        <div className='onlinepbx__burger__menu__text'>Меню</div>
      </div>
      {isActiveMenu && <div
        onClick={handleToggle}
        className='onlinepbx__burger__menu__open'>
        <div>
          <button
            onClick={onClick}
            className='onlinepbx__menu__button__fill'>
            Регистрация
          </button>
          <button
            onClick={() => window.open(`${link}/login`, '_blank')}
            className='onlinepbx__menu__button__border'>
            Вход
        </button>
          <a href='tel:+998781132266' className='onlinepbx__burger__menu__open__phone'>
            +998 (78) 113-22-66
        </a>
        </div>
      </div>}
    </>
  )
}

export default BurgerMenu
